<template>
  <div v-if="type === 'chat'" class="toast-container" @touchstart="onStartScroll" @click="onClick">
    <img :src="userImage" alt="유저" class="user-image" />
    <div class="toast-chat-message-container">
      <div class="user-name">{{username}}</div>
      <div class="message">{{content}}</div>
    </div>
    <div class="close-button" @click.stop="onClose"></div>
  </div>
  <div v-else class="toast-container" :class="{isOpenControlMenu}" @touchstart="onStartScroll">
    <div class="toast-icon" :class="type"></div>
    <div class="toast-chat-message-container">
      <div class="message">{{message}}</div>
      <div v-if="content" class="toast-content">{{content}}</div>
    </div>
    <div class="close-button" @click.stop="onClose"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ToastMessage',
  props: {
    type: {
      type: String,
      default: 'success',
    },
    message: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    userImage: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
    click: {
      type: Function,
      default: () => {},
    }
  },
  computed: {
    ...mapGetters('common', ['isOpenControlMenu'])
  },
  mounted() {
    setTimeout(() => {
      this.$el.classList.remove('fadeOpacity');
      this.$el.style.opacity = '1';
    }, 200);
    setTimeout(() => {
      this.onClose();
    }, 5000)
  },
  methods: {
    onClose(){
      this.destroy({fade: false, fadeOpacity: true});
    },
    onStartScroll(e) {
      if (!e.touches) return;

      const toast = this.$el;
      const startY = e.touches[0].clientY;

      const onTouchMove = (moveEvent) => {
        const currentY = moveEvent.touches[0].clientY;
        const deltaY = currentY - startY;

        if (deltaY < 0) { // 위로 스와이프 중
          toast.style.transition = 'none';
          toast.style.transform = `translate(-50%, ${deltaY}px)`;

          const opacity = Math.max(0.2, 1 + deltaY / 120);
          toast.style.opacity = opacity;
        }
      };

      const onTouchEnd = (endEvent) => {
        const endY = endEvent.changedTouches[0].clientY;
        const totalMove = startY - endY;

        if (totalMove > 30) {
          this.onClose();
        } else {
          toast.style.transform = '';
          toast.style.opacity = '';
        }

        window.removeEventListener('touchmove', onTouchMove);
        window.removeEventListener('touchend', onTouchEnd);
      };

      window.addEventListener('touchmove', onTouchMove);
      window.addEventListener('touchend', onTouchEnd);
    },
    onClick(){
      this.click()
      this.onClose()
    }
  }
}
</script>

<style scoped lang="scss">
.toast-container{
  position: absolute;
  top: 8px;
  transition: bottom 0.1s ease-out;
  line-height: 1.5;
  @media(orientation: landscape) {
    max-width: 374px;
  }
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;

  border-radius: 12px;
  background: rgba(49, 49, 49, 0.8);
  backdrop-filter: blur(10px);
  display: flex;
  width: calc(100dvw - 16px);
  padding: 12px 20px;
  align-items: center;
  color: #FFF;
  .toast-message{
    font-size: 14px;
    font-weight: 700;
    margin-left: 14px;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  }
  .toast-content{
    font-size: 14px;
    font-weight: 700;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  }
  .toast-icon{
    width: 16px;
    height: 16px;

    &.success{
      background: url("~@/assets/images/camstudy/ico_toast_success.svg") no-repeat;
      background-size: auto 16px;
    }
    &.error{
      background: url("~@/assets/images/camstudy/ico_toast_error.svg") no-repeat;
      background-size: auto 16px;
    }
    &.info{
      background: url("~@/assets/images/camstudy/ico_toast_info.svg") no-repeat;
      background-size: auto 16px;
    }
    &.content{
      background: url("~@/assets/images/camstudy/ico_toast_content.svg") no-repeat;
    }
  }
  .user-image{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .toast-chat-message-container{
    margin-left: 14px;
    color: #FFF;
    font-size: 14px;
    line-height: 150%;
    width: calc(100% - 80px);
    display: flex;
    flex-direction: column;
    justify-content: center;

    .user-name{
      font-weight: 700;
      overflow: hidden;
      text-wrap: nowrap;
      text-overflow: ellipsis;
      width: 100%;
    }
    .message{
      overflow: hidden;
      text-wrap: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      font-size: 14px;
      font-weight: 700;
    }
  }
  .close-button{
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") no-repeat center center;
  }
}
</style>